import { render, staticRenderFns } from "./TriggeredReferralForm.vue?vue&type=template&id=55671cfe&"
import script from "./TriggeredReferralForm.vue?vue&type=script&lang=ts&"
export * from "./TriggeredReferralForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports